import { jsxs, jsx } from 'react/jsx-runtime';
import { styled } from '@mui/material';
import { Helmet } from 'react-helmet';

const PreloadFonts = () => {
    return (jsxs(Helmet, { children: [jsx("link", { rel: "preconnect", href: "https://fonts.googleapis.com" }), jsx("link", { href: "https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap", rel: "stylesheet" })] }));
};
const GenericContainer = styled('div')({
    fontFamily: 'Poppins, sans-serif',
});

export { GenericContainer, PreloadFonts };
//# sourceMappingURL=GenericContainer.js.map
